// This code was provided by a Third party

REDIRECTURL="https://returnsportal.co/r/rosefieldwatches-LOCALE?o=ORDERNUMBER&e=EMAIL"
orderCode="";
email="";
LOCALES=["NL","DE","IT","FR","ES","EU","US","CA","AUS","UK","USA"];

function onChangeOrderCode(){
    orderCode=document.getElementById("order").value
    checkValues();
}

function onChangeEmail(){
    email=document.getElementById("email").value
    checkValues();
}

function checkValues(){
    if(validateOrderCode())
        document.getElementById("error-ordercode").classList.remove('show');
    if(validateEmail())
        document.getElementById("error-email").classList.remove('show');
    if(validateOrderCode() && validateEmail()){
        document.getElementById("start-return").disabled=false;
    } else {
        document.getElementById("start-return").disabled=true;
        if(orderCode.length>1 && !validateOrderCode())
            document.getElementById("error-ordercode").classList.add('show');
        if(email.length>1 && !validateEmail())
            document.getElementById("error-email").classList.add('show');
    }
}

function startReturn(){
    initial=getLocaleFromOrderCode(orderCode);
    redirectUrl=REDIRECTURL.replace("ORDERNUMBER",orderCode).replace("EMAIL",email).replace("LOCALE",initial.toLowerCase());
    window.location.href = redirectUrl;
}

function getLocaleFromOrderCode(ordercode){
    stringToReturn="";
    stringToReturn=ordercode.slice(0,3);
    if(stringToReturn.toUpperCase()!=="AUS" && stringToReturn.toUpperCase()!=="USA")
        stringToReturn=stringToReturn.slice(0,2)
    return stringToReturn;
}

function validateEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validateOrderCode(){
    initial=getLocaleFromOrderCode(orderCode)
    return LOCALES.includes(initial.toUpperCase())
}

window.onload=()=>{
    checkValues()
}
